import { Directive, Input, TemplateRef, ViewChild } from '@angular/core';
import { compareObject } from '@clean-code/shared/common';
import type { Observable } from 'rxjs';
import { BehaviorSubject, distinctUntilChanged, filter } from 'rxjs';
import { IDashboardWidgetTypeConfig } from '../models/widget-type.models';
import { IWidgetTypeContentComponent } from '../models/widget-types-content.models';
import { IDashboardWidgetDetailDto } from '../models/widget.models';

@Directive()
export class BaseWidgetTypeContentComponent<
  T extends IDashboardWidgetTypeConfig
> implements IWidgetTypeContentComponent
{
  @ViewChild('headerTemplate')
  public headerTemplate?: TemplateRef<unknown>;

  protected readonly config$ = new BehaviorSubject<T | null>(null);
  protected readonly configObservable: Observable<T> = this.config$.pipe(
    filter((x): x is T => x !== null),
    distinctUntilChanged((x, y) => compareObject(x, y)),
  );

  @Input()
  public set config(config: T) {
    this.config$.next(config);
  }

  public get config(): T | null {
    return this.config$.value;
  }

  protected widgetInternal?: IDashboardWidgetDetailDto;
  @Input()
  public set widget(val: IDashboardWidgetDetailDto) {
    if (val) {
      this.widgetInternal = val;
    }
  }

  public get widget(): IDashboardWidgetDetailDto | undefined {
    return this.widgetInternal;
  }
}
